// extracted by mini-css-extract-plugin
export default {"property-rental-label":"property-rental-label-f95c"};